export function equals(value1, value2) {
    if (value1 instanceof Array && value2 instanceof Array) {
        return value1.length == value2.length && value1.every(function (v, i) { return v == value2[i]; });
    }
    return value1 == value2;
}
